<template>
<el-dialog title="完成订单" :visible.sync="dialogVisible" width="800px" @close="handleClose" class="accomplish-order-dialog" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-scrollbar class="accomplish-order-dialog-scroll" v-loading="contentLoading">
        <div class="module-name">订单信息</div>
        <div class="info-item">
            <div class="label">用户名称：</div>
            <div class="value">{{details.customername}}({{details.customerinnerid}})</div>
        </div>
        <div class="info-item">
            <div class="label">手机号码：</div>
            <div class="value">{{details.mobileno}}</div>
        </div>
        <div class="info-item">
            <div class="label">订单号：</div>
            <div class="value">{{details.orderno}}</div>
        </div>
        <div class="info-item">
            <div class="label">订单类型：</div>
            <div class="value">{{details.ordertypename}}</div>
        </div>
        <div class="info-item">
            <div class="label">产品名称：</div>
            <div class="value">{{details.productname}}</div>
        </div>
        <div class="info-item">
            <div class="label">付款方式：</div>
            <div class="value">{{details.paytypename}}</div>
        </div>
        <div class="info-item">
            <div class="label">支付金额：</div>
            <div class="value">{{details.finalpaymoney ? (details.finalpaymoney + '元') : '--'}}</div>
        </div>
        <div class="info-item">
            <div class="label">订单时间：</div>
            <div class="value">{{details.orderdatetime}}</div>
        </div>
        <div class="module-name" style="margin-top: 20px">订单处理</div>
        <div class="info-item" style="align-items: center;">
            <div class="label">付款方式：</div>
            <div class="value">
                <el-select v-model="params.paytype" style="width: 300px" placeholder="请选择支付方式">
                    <el-option v-for="item in paytypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </div>
        </div>
        <div class="info-item" style="align-items: center;">
            <div class="label">支付时间：</div>
            <div class="value">
                <el-date-picker v-model="params.paydatetime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" style="width: 300px" type="datetime" placeholder="请选择支付时间"></el-date-picker>
            </div>
        </div>
        <div class="info-item">
            <div class="label"></div>
            <div class="value">
                <el-button @click="handleClose">取消</el-button>
                <el-button type="primary" @click="handleUpdateTopicQuestionbankOrderFinish" :loading="loading">确定</el-button>
            </div>
        </div>
    </el-scrollbar>
</el-dialog>
</template>

<script>
import {getTopicQuestionbankOrderDetail, updateTopicQuestionbankOrderFinish} from 'api/questionApi'
export default {
    name: 'orderDetailsDialog',
    data() {
        return {
            dialogVisible: false,
            orderno: '',
            contentLoading: false,
            details: {},
            params: {
                orderno: '',
                paydatetime: '',
                paytype: ''
            },
            paytypeList: [
                {label: '支付宝支付', value: 1},
                {label: '微信支付', value: 2}
            ],
            loading: false
        }
    },
    mounted() {
    },
    methods: {
        handleOpen(row) {
            this.dialogVisible = true
            this.orderno = row.orderno
            this.params.orderno = row.orderno
            this.handleGetTopicQuestionbankOrderDetail(this.orderno)
        },
        handleClose() {
            this.dialogVisible = false
            this.orderno = ''
            this.details = {}
            this.params = {
                orderno: '',
                paydatetime: '',
                paytype: ''
            }
        },
        handleGetTopicQuestionbankOrderDetail(orderno) {
            this.contentLoading = true
            getTopicQuestionbankOrderDetail({
                data: {
                    code: orderno,
                    apptype: 0
                },
                success: data => {
                    this.details = data.data
                    this.contentLoading = false
                },
                error: data => {
                    this.contentLoading = false
                    this.$message.error(data.msg)
                }
            })
        },
        handleUpdateTopicQuestionbankOrderFinish() {
            if (!this.params.paytype) {
                this.$message.warning('请选择支付方式！')
            } else if (!this.params.paydatetime) {
                this.$message.warning('请选择支付时间！')
            } else {
                this.loading = true
                updateTopicQuestionbankOrderFinish({
                    data: this.params,
                    success: data => {
                        this.loading = false
                        this.$message.success('操作成功！')
                        this.$emit('handleAccomplishOrderSuccess', JSON.parse(JSON.stringify(this.params)))
                        this.handleClose()
                    },
                    error: error => {
                        this.loading = false
                        this.$message.error(error.msg)
                    }
                })
            }
        }
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.accomplish-order-dialog {
    .el-dialog {
        height: 515px;
        .el-dialog__body {
            height: 470px;
            box-sizing: border-box;
            padding: 0;
            .accomplish-order-dialog-scroll {
                height: 100%;
                .el-scrollbar__view {
                    padding: 20px !important;
                    box-sizing: border-box;
                    .module-name {
                        font-size: 16px;
                        color: #333333;
                        font-weight: bold;
                        display: flex;
                        align-items: center;
                        margin-bottom: 15px;
                        &::before {
                            content: '';
                            width: 4px;
                            height: 20px;
                            background: #409EFF;
                            margin-right: 5px;
                        }
                    }
                    .info-item {
                        display: flex;
                        margin-bottom: 10px;
                        line-height: 18px;
                        .label {
                            width: 70px;
                            color: #666666;
                            font-size: 14px;
                        }
                        .value {
                            flex: 1;
                            width: 0;
                            color: #333333;
                            font-size: 14px;
                            .el-button {
                                margin-bottom: 0;
                            }
                            .el-input__icon {
                                line-height: 32px;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>